import { useAuth } from "@/hooks/useAuth";
import { usePassesForSale } from "@/hooks/usePassesForSale";
import { useRouter } from "expo-router";
import { useState } from "react";

interface Pass {
  passName: string;
  rateProductID: string;
  passNotes: string[];
  amount: number;
  locationName: string;
  showNotRedeemableWarning: boolean;
}

export function usePurchaseFlexPark() {
  const { user } = useAuth();
  const router = useRouter();
  const { passesForSale, isFetching } = usePassesForSale();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRateProductID, setSelectedRateProductID] = useState<string | null>(null);

  const passes = passesForSale?.passesForSale as Pass[] | undefined;

  const handlePurchase = (rateProductID: string) => {
    setSelectedRateProductID(rateProductID);
    const selectedPass = passes?.find((pass) => pass.rateProductID === rateProductID);

    if (!user || selectedPass?.showNotRedeemableWarning) {
      setIsModalOpen(true);
    } else {
      processPurchase(rateProductID);
    }
  };

  const processPurchase = async (rateProductID: string) => {
    const selectedPass = passes?.find((pass) => pass.rateProductID === rateProductID);
    const rateName = selectedPass?.passName;
    try {
      router.push({
        params: { isPurchasingPass: "true", rateID: rateProductID, rateName },
        pathname: "/cart",
      });
    } catch (error) {
      console.error("Error processing purchase:", error);
    }
  };

  return {
    user,
    passes,
    isFetching,
    isModalOpen,
    selectedRateProductID,
    handlePurchase,
    setIsModalOpen,
    processPurchase,
  };
}
